// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Enums
import { ScatterPlotPlotType } from 'ChartApp/ts/enums/scatter-plot-common.enum';
// Action imports
import { setScatterPlot } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.actions';
import { setYAxisDate } from './y-axis-date.actions';
export const yAxisDate = createReducer(null, on(setScatterPlot, (state, action) => {
    if (action.scatterPlot.plotType === ScatterPlotPlotType.pointInTime) {
        return action.scatterPlot.yAxisDate;
    }
    return state;
}), on(setYAxisDate, (state, { date }) => {
    return date;
}));
